import { Card } from "@/components/ui/card";
import { Heading } from "@/components/ui/heading";
import { Text } from "@/components/ui/text";
import { PropsWithChildren, PropsWithoutRef } from "react";

export function EmptyState(
  props: PropsWithChildren<{
    title: string;
    description?: string;
    variant?: "ghost" | "outline" | "elevated" | "filled";
  }>
) {
  return (
    <Card size="lg" variant={props.variant ?? "outline"}>
      <Heading size="md" className="mb-1 text-center">
        {props.title}
      </Heading>
      {props.description && (
        <Text size="sm" className="text-center">
          {props.description}
        </Text>
      )}
      {props.children}
    </Card>
  );
}
